import { useMemo } from "react";
import { YAxisPlotBandsOptions, YAxisPlotLinesOptions } from "highcharts";

import { LineGraphWidgetConfiguration } from "@/lib/api";
import COLORS from "@/features/shared/widgets/graphs/colors";

export const useThresholdsY = (configuration: LineGraphWidgetConfiguration) => {
  return useMemo(() => {
    if (!configuration.thresholds || configuration.thresholds.length === 0) return [];

    return configuration.thresholds.reduce<
      [YAxisPlotLinesOptions[], YAxisPlotBandsOptions[]]
    >(
      (acc, threshold) => {
        const value = Number(threshold.value);
        const label = {
          text: `<span class="chart__show-on-hover">${threshold.title} (${threshold.value})</span>`,
          useHTML: true,
        };

        if (threshold.threshold_type === "line") {
          acc[0].push({
            id: threshold.id,
            value: value,
            color:
              threshold.color && threshold.color in COLORS.LINES
                ? COLORS.LINES[threshold.color as keyof typeof COLORS.LINES]
                : undefined,
            label,
            zIndex: 2,
          });
        }

        if (threshold.threshold_type === "max") {
          acc[0].push({
            id: `${threshold.id}_line`,
            value,
            color:
              threshold.color && threshold.color in COLORS.LINES
                ? COLORS.LINES[threshold.color as keyof typeof COLORS.LINES]
                : COLORS.LINES.red,
            label,
            zIndex: 5,
          });
        }

        if (threshold.threshold_type === "min") {
          acc[0].push({
            id: `${threshold.id}_line`,
            value,
            color:
              threshold.color && threshold.color in COLORS.LINES
                ? COLORS.LINES[threshold.color as keyof typeof COLORS.LINES]
                : COLORS.LINES.blue,
            label,
            zIndex: 5,
          });
        }

        return acc;
      },
      [[], []],
    );
  }, [configuration]);
};
